import request from './request';

// 获取vip奖励配置
export const getVipInfo = () =>
  request({
    url: '/carbon-promotion/private/user/activity/vip/homepage',
    method: 'GET'
  });

export const getVipInfoWithoutAuth = () =>
  request({
    url: '/carbon-promotion/public/activity/vip/homepage',
    method: 'GET'
  });

export const getVipHistory = ({ pageIndex, pageSize }: { pageIndex: number, pageSize: number }) =>
  request({
    url: '/carbon-promotion/private/user/activity/vip/record',
    method: 'GET',
    params: {
      pageIndex,
      pageSize,
    }
  });